import { Pipe, PipeTransform } from "@angular/core";

@Pipe({ name: "sameType", pure: true })
export class SameType implements PipeTransform {
  transform(currentTableDataList: any, selected: any, lookUpItemList: any) {
    if (lookUpItemList && lookUpItemList.length && selected && currentTableDataList.length) {
      let list = [];
      list = lookUpItemList.filter(a => {
        if (a.name == selected) {
          return true;
        }
        else {
          return false;
        }
      });
      return currentTableDataList.filter(
        a => {
          if (
            (list && list.length && a.type == list[0].type) || // Existing conditions
            (list[0].type == 'formula' && list[0].options[0].type == 'string' && a.type == 'text') ||
            (list[0].type == 'formula' && list[0].options[0].type == 'number' && a.type == 'number')
          ) {
            if (!(list[0].type == 'formula' && a.type == 'formula')) { // Check for the exception
              return true;
            }
          }
          else {
            return false;
          }
        }
      );
    } else {
      return currentTableDataList;
    }
  }
}
